<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="userFinanceTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction"></wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_FINANCE_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablUserFinanceStats/dataList' }
        },
        formInputsData: [
          { name: '统计时间',
            key: 'status',
            value: 'day',
            type: 'select',
            data: [
              { label: '天', value: 'day' },
              { label: '周', value: 'week' },
              { label: '月', value: 'month' },
              { label: '年', value: 'year' }
            ] },
          { name: 'userid', key: 'userId', value: '', type: 'text' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablUserFinanceStats/exportExcel',
          fileName: '用户财务统计',
          permission: 'EXPORT' }],
        formTableData: [
          { name: 'userid', key: 'userId', type: 'text' },
          { name: '公司名称', key: 'companyName', type: 'text' },
          { name: '提现金额(元)', key: 'withdrawDeposit', type: 'text' },
          { name: '投递金额(元)', key: 'userReceivedAmount', type: 'text' },
          { name: '提现时间', key: 'statsDate', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
